import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalyticsConditional = ({ trackingId }) => {
    const location = useLocation();
    const heartbeatIntervalRef = useRef(null);

    useEffect(() => {
        const currentTitle = document.title;

        const initializeGtag = (trackingId) => {
            // If the Google Analytics script hasn't been loaded, add it
            if (!window.dataLayer) {
                const script = document.createElement('script');
                script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
                script.async = true;
                document.head.appendChild(script);
            }

            // Initialize GA with the correct tracking ID
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }

            gtag('js', new Date());
            gtag('config', trackingId, {
                page_path: location.pathname + location.search,
            });

            // Ensure the heartbeat event fires every 10 seconds
            if (!heartbeatIntervalRef.current) {
                heartbeatIntervalRef.current = setInterval(() => {
                    if (gtag) {
                        gtag('event', 'heartbeat', {
                            event_category: 'engagement',
                            event_label: 'user_active',
                            value: 1,
                        });
                    }
                }, 10000);
            }

            // Clean up the interval when the component is unmounted or location changes
            return () => {
                if (heartbeatIntervalRef.current) {
                    clearInterval(heartbeatIntervalRef.current);
                    heartbeatIntervalRef.current = null;
                }
            };
        };

        // Reinitialize with the correct tracking ID based on the current title
        if (currentTitle !== "UfoneEsl" && currentTitle !== "Login | UfoneEsl") {
            initializeGtag(trackingId); // Use home tracking ID for all other titles
        }
    }, [location, trackingId]); // Re-run effect when location changes

    return null; // This component does not render any visible content
};

export default GoogleAnalyticsConditional;